module.exports = __webpack_public_path__ + "img/apoint.98dbc1cf.png";